<template>
    <div>
        <loading-custom :loading="loading" />
        
        <div class="table-responsive">
            <table class="table table-hover mb-0 c_list">
                <thead>
                    <tr>
                        <th scope="col" class="tw-w-1/12">รูปภาพ</th>
                        <th scope="col" class="tw-w-2/12">ชื่อสินค้า</th>
                        <th scope="col" class="tw-w-2/12">
                            หมวดหมู่สินค้า
                        </th>
                        <th  scope="col" class="tw-w-1/12 text-right">ราคา <span class="tw-text-sm">({{ currency ? currency.name : '' }})</span></th>
                        <th scope="col" class="tw-w-1/12 text-right">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-if="
                            tableData.data
                                ? tableData.data.length === 0
                                : tableData.data
                        "
                    >
                        <td class="text-center" colspan="5">
                            ไม่พบข้อมูล
                        </td>
                    </tr>
                    <tr v-for="(item, index) in tableData.data" :key="index" @click="openProductDetail(item)">
                        <td>
                            <div class="image-container tw-rounded-lg overflow-hidden">
                                <img
                                    class="tw-w-full tw-object-cover tw-h-full"
                                    :src="item.image_url"
                                    alt="product picture"
                                />
                            </div>
                            <!-- <img
                                class="table-image"
                                :src="item.image_thumb_url"
                                alt=""
                            /> -->
                            <!-- <div v-html="item.image_media"></div> -->
                        </td>
                        <td class="sm:text-xs">
                            {{ item.name }}
                        </td>
                        <td class="tw-flex tw-flex-wrap">
                            <span class="badge badge-default p-1 m-1 text-xs" v-for="(item, index) in item.categories" :key="index"> 
                                <i class="mr-1" :class="'fa ' + item.icon"></i> {{ item.title }}
                            </span>
                        </td>
                        <td class="text-right">
                            {{
                                Number(item.price).toLocaleString(undefined, {
                                    minimumFractionDigits: 2
                                })
                            }}
                        </td>
                        <td class="text-right">
                            <a
                                :href="
                                    `/backend/s/${shop}/products/${item.id}/edit/`
                                "
                            >
                                <button
                                    type="button"
                                    class="btn btn-sm btn-warning"
                                    title="Edit"
                                    v-on:click.stop=";"
                                >
                                    <i class="fa fa-edit"> แก้ไข </i>
                                </button>
                            </a>
                            <button
                                v-on:click.stop="confirmDelete(item.id)"
                                type="button"
                                data-type="confirm"
                                class="btn btn-sm btn-danger js-sweetalert"
                                title="Delete"
                            >
                                <i class="fa fa-trash-o"> ลบ</i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="tw-flex tw-mt-5  tw-justify-center lg:tw-justify-end">
            <paginate
                :data="tableData"
                :page="page"
                @onPage="onPage($event)"
                v-show="tableData.total > 0"
            ></paginate>
        </div>

        <!-- Product Detail -->
        <product-detail-component 
            :product="productDetail" 
            :isOpen="productDetailOpen" 
            :shop="shop" 
            :currency="currency"
            @closeModal="closeProductDetail" 
            @onUpdate="onUpdate"
        />
    </div>
</template>
<script type="application/javascript">
import paginate from "../../helper/Paginate.vue";

export default {
    props: ["shop"],
    components: {
        paginate
    },
    data() {
        return {
            page: 1,
            loading: false,
            tableData: [],
            currency: null,

            productDetailOpen: false,
            productDetail: null
        };
    },
    mounted() {
        this.getData();
        this.getCurrency();
    },
    methods: {
        onPage(page) {
            this.page = page;
            this.getData();
        },
        async getData() {
            // this.loading = false;
            await axios
                .get(`/ajax/s/${this.shop}/products?page=${this.page}`)
                .then(res => {
                    this.tableData = res.data.product;
                });
        },
        confirmDelete(id) {
            this.$swal({
                icon: "warning",
                title: "ต้องการลบสินค้าใช่ไหม?",
                text: "เมื่อกดยืนยัน สินค้าจะถูกลบ",
                confirmButtonText: "ยืนยัน",
                showCancelButton: true,
                cancelButtonText: "ยกเลิก",
                reverseButtons: true
            }).then(result => {
                if (result.isConfirmed) {
                    this.deleteProduct(id);
                }
            });
        },
        async deleteProduct(id) {
            this.loading = true;
            await axios
                .delete(`/ajax/s/${this.shop}/products/${id}`)
                .then(res => {
                    this.getData();
                     this.loading = false;
                })
                .catch(err => {});
        },
        async getCurrency() {
            this.loading = true;
            await axios
                .get(`/ajax/frontend/s/${this.shop}/currency`)
                .then(res => {
                    this.currency = res.data.currency;
                })
                .catch(err => {
                    console.log(err.response.data);
                })
                .then(() => {
                    this.loading = false;
                });
        },
        async onUpdate() {
            await this.getData()
                .then(() => {
                    this.productDetail = this.salePageProductData.find(product => {
                        return product.id == this.productDetail.id
                    })
                });
        },
        openProductDetail(product) {
            this.productDetail = product;
            this.productDetailOpen = true;
        },
        closeProductDetail() {
            this.productDetailOpen = false;
            this.productDetail = null;
        },
    }
};
</script>
<style lang="scss" scoped>
.table-image {
    width: 120px;
    // max-width: 200px;
}

.text-ellipsis {
    width: 30%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.image-container {
    width: 100%;
    aspect-ratio: 1 / 1;
}

.image-container img {
    height: 100%;
    width: 100%;
    object-fit: cover;
}
</style>
